import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import catedral from 'resources/icons/catedral.png'; //Eliminar
import ayuntamiento from 'resources/icons/ayuntamiento.png'; //Eliminar
import castillo from 'resources/icons/castillo.png'; //Eliminar
import museo from 'resources/icons/museo.png'; //Eliminar

export interface News {
  visitPalmaCategories:Array<any>,
  visitPalma:Array<any>,
  selectedNew:null,
  selectedEmtNew:null,
  selectedMainEmtNew:null,
  news: {
    pagination: {
      total: number,
      page: number,
      elements: 10
    },
    data: Array<any>
  }
}

const initialState : News = {
  visitPalmaCategories:[
    {
        id:1,
        name:'Rutas',
    },
    {
        id:2,
        name:'Patios y casales',
    },
    {
        id:3,
        name:'Monumentos',
    },
    {
        id:4,
        name:'Museos',
    },
    {
        id:5,
        name:'Música',
    }
  ],
  visitPalma: [{
    img:catedral,
    date:'27 de mayo 2023',
    title:'Catedral',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
},
{
    img:ayuntamiento,
    date:'28 de mayo 2023',
    title:'Ayuntamiento',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
},
{
    img:castillo,
    date:'29 de mayo 2023',
    title:'Castillo',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
},
{
    img:museo,
    date:'30 de mayo 2023',
    title:'Museos',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
},
{
    img:catedral,
    date:'29 de mayo 2023',
    title:'Palma de Mallorca',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
},
{
    img:ayuntamiento,
    date:'30 de mayo 2023',
    title:'Palma de Mallorca',
    description:'Nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible nueva inversión de seis millones de euros para renovar las paradas e instalar marquesinas dotadas de mobiliario y accesible.'
}],
  news: {
    pagination: {
      total: 0,
      page: 1,
      elements: 10
    },
    data: []
  },
  selectedNew:null,
  selectedEmtNew:null,
  selectedMainEmtNew:null,
};

export const newsSlice = createSlice({
  name: 'newsSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateNews: (state, action) => {
      state.news = action.payload;
    },
    updateSelectedNew: (state, action) => {
      state.selectedNew = action.payload;
    },
    updateSelectedEmtNew: (state, action) => {
      state.selectedEmtNew = action.payload;
    },
    updateSelectedMainEmtNew: (state, action) => {
      state.selectedMainEmtNew = action.payload;
    },
  },
});

export const { updateNews, updateSelectedNew, updateSelectedMainEmtNew, updateSelectedEmtNew } = newsSlice.actions;
export const newsState = (state: RootState) => state.news.news;
export const selectedNewState = (state: RootState) => state.news.selectedNew;
export const selectedNewEmtState = (state: RootState) => state.news.selectedEmtNew;
export const selectedMainEmtNewState = (state: RootState) => state.news.selectedMainEmtNew;
export const visitPalma = (state: RootState) => state.news.visitPalma;
export const visitPalmaCategoriesState = (state: RootState) => state.news.visitPalmaCategories;

export default newsSlice.reducer;
